import { z } from "zod";

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.email({ message: "Informe um e-mail válido." }))
  .refine((v) => v.length <= 254, "E-mail muito longo.");

export const passwordSchema = z
  .string()
  .min(8, "A senha precisa ter pelo menos 8 caracteres.")
  .max(128, "A senha pode ter até 128 caracteres.")
  .refine((v) => /[A-Za-zÀ-ÿ]/.test(v) && /\d/.test(v), "A senha precisa combinar letras e números.");

const nameSchema = z.string().trim().min(2, "Informe seu nome completo.").max(120);

/** Aceite obrigatório: as versões vigentes dos documentos são registradas pelo servidor. */
const acceptSchema = z.literal(true, {
  message: "É preciso aceitar os termos de uso e a política de privacidade.",
});

export const registerSchema = z.object({
  institutionSlug: z.string().trim().toLowerCase().min(2).max(60),
  name: nameSchema,
  email: emailSchema,
  password: passwordSchema,
  acceptTerms: acceptSchema,
});

export const registerInstitutionSchema = z.object({
  institutionName: z.string().trim().min(2, "Informe o nome da instituição.").max(120),
  name: nameSchema,
  email: emailSchema,
  password: passwordSchema,
  acceptTerms: acceptSchema,
});

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, "Informe a senha.").max(128),
});

export const forgotPasswordSchema = z.object({ email: emailSchema });

export const resetPasswordSchema = z.object({
  token: z.string().min(20).max(200),
  password: passwordSchema,
});

export const createUserSchema = z.object({
  name: nameSchema,
  email: emailSchema,
  profile: z.enum(["student", "facilitator", "teacher", "admin", "platform_admin"]),
  password: passwordSchema.optional(),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type RegisterInstitutionInput = z.infer<typeof registerInstitutionSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type CreateUserInput = z.infer<typeof createUserSchema>;
